import { m } from "@/paraglide/messages";
import type { UserSubscription } from "@bidbattles/bloks/lib/rapace";
import {
	hadPremiumSubscription,
	hasCancelledPremiumSubscription,
} from "@bidbattles/bloks/lib/utils";

export function getSubscriptionLabel(
	sub?: UserSubscription,
	{ withStatusSuffix = true }: { withStatusSuffix?: boolean } = {},
) {
	let label = m[`subscription_tier__${sub?.tier ?? "FREE"}`]();

	if (sub && withStatusSuffix && hadPremiumSubscription(sub)) {
		if (hasCancelledPremiumSubscription(sub)) {
			label = `${label} • Cancelled`;
		} else {
			label = `${label} • Expired`;
		}
	}

	return label;
}

export { hadPremiumSubscription, hasCancelledPremiumSubscription };
export { hasPremiumSubscription } from "@bidbattles/bloks/lib/utils";
